import { render } from "./SiteHeadingExpandable.vue?vue&type=template&id=00f26c96"
import script from "./SiteHeadingExpandable.vue?vue&type=script&lang=js"
export * from "./SiteHeadingExpandable.vue?vue&type=script&lang=js"

import "./SiteHeadingExpandable.vue?vue&type=style&index=0&id=00f26c96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__